// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NOvlBxSS_xkk0X6NYUxw{flex-direction:column;gap:24px;display:flex}.l5rMvygBp8crVqX7NcKu{gap:8px;display:flex}.eU_anhUOUcY4BMXf252n{color:var(--content-primary-primary)}.eU_anhUOUcY4BMXf252n span{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrap": `NOvlBxSS_xkk0X6NYUxw`,
	"actionsWrap": `l5rMvygBp8crVqX7NcKu`,
	"dropdown__item": `eU_anhUOUcY4BMXf252n`,
	"dropdownItem": `eU_anhUOUcY4BMXf252n`
};
export default ___CSS_LOADER_EXPORT___;
